import { useSelector } from "react-redux";
import {
  clearQuote,
  removeFromQuote,
} from "../redux/slices/FavouriteItemSlice";
import { RootState } from "../redux/Store";
import { FaTrashCan } from "react-icons/fa6";
import Navbar from "../components/Navbar";
import emailjs from "emailjs-com";
import { useAppDispatch } from "../redux/hooks";
import { useState } from "react";
import BottomNavbar from "../components/BottomNavbar";
import { useNavigate } from "react-router-dom";

export default function CartPage() {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const State = useSelector((state: RootState) => state);
  const userProfile = State.Profile[0];

  // Fetch items from Redux store
  const quoteItems = useSelector(
    (state: RootState) => state.FavouriteFood.quoteItems
  );

  const handleRequestQuote = async () => {
    setIsLoading(true);
    if (quoteItems.length === 0) {
      navigate("/products");
      return;
    }

    const templateParams = {
      to_email: "info@rehobothstandardcables.com",
      from_name: userProfile?.email || "No email provided",
      message:
        `Sender: ${userProfile?.name || "No name provided"}\nEmail: ${
          userProfile?.email || "No email provided"
        }\n\nRequested Items:\n` +
        quoteItems.map((item) => `- ${item.name}: ${item.specs}`).join("\n"),
    };

    try {
      await emailjs.send(
        "service_or2tnhe", // Replace with EmailJS Service ID
        "template_31ptbtt", // Replace with EmailJS Template ID
        templateParams,
        "fqI3PocVmWddH719H" // Replace with EmailJS Public Key
      );

      alert("Your quote request has been sent successfully!");
      dispatch(clearQuote());
    } catch (error) {
      console.error("Error sending quote request:", error);
      alert("An error occurred while sending the quote request.");
    }
    setIsLoading(false);
  };

  return (
    <>
      <Navbar current="cart" />
      <div className="max-w-4xl mx-auto p-6 pt-24 pb-20">
        <h1 className="text-2xl font-bold mb-4">🛒 Your Cart</h1>

        {quoteItems.length === 0 ? (
          <p className="text-gray-500">Your cart is empty.</p>
        ) : (
          <div className="space-y-4">
            {quoteItems.map((item: any) => (
              <div
                key={item.id}
                className="flex items-center justify-between bg-white shadow-md rounded-xl p-2"
              >
                <img
                  src={item.image}
                  alt={item.name}
                  className="w-16 h-16 object-cover rounded-lg"
                />
                <div className="flex-1 ml-4">
                  <h2 className="text-lg font-semibold">{item.name}</h2>
                  <p className="text-gray-500 text-sm">{item.specs}</p>
                </div>
                <button
                  onClick={() => dispatch(removeFromQuote(item.id))}
                  className="text-red-500 hover:text-red-700"
                >
                  <FaTrashCan size={20} />
                </button>
              </div>
            ))}
          </div>
        )}

        <button
          onClick={handleRequestQuote}
          disabled={isLoading}
          className={`px-4 py-2 text-sm mt-12 right-0 rounded-lg text-white bg-primary hover:bg-primary-dark ${
            isLoading && "animate-pulse"
          }`}
        >
          {isLoading
            ? "Sending..."
            : `${quoteItems.length < 1 ? "Add Items" : "Request Quote"}`}
        </button>
      </div>
      <BottomNavbar current="cart" />
    </>
  );
}
